import { useLocation } from 'react-router-dom';

export const useUrlQuery = () => {
  const { search } = useLocation();
  return new URLSearchParams(search);
};
